import { useWindowDimensions } from "hooks/useWindowDimensions";

export const useGetSliderResponsiveOptions = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const slidesToShow = isMobile ? 2 : 4;
  const slidesToScroll = isMobile ? 1 : 4;

  return {
    slidesToShow,
    slidesToScroll
  };
};
